<template>
  <v-menu
    open-on-hover
    :open-delay="openDelay"
    :location="location"
    :disabled="disabled"
    style="z-index: 100000"
  >
    <template #activator="{ props }">
      <slot v-bind="props"> </slot>
    </template>

    <v-card :color="isDarkMode ? 'grey-darken-1' : ''" style="max-width: 27em">
      <v-list-item density="compact" nav>
        <v-list-item-title class="text-wrap">
          {{ title }}
        </v-list-item-title>
        <v-list-item-subtitle class="text-wrap" style="hyphens: auto">
          {{ description }}
        </v-list-item-subtitle>
      </v-list-item>
      <v-card-actions v-if="$slots.action">
        <v-spacer></v-spacer>
        <slot name="action"></slot>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>
<script>
export default {
  name: 'BasicTooltip',
  props: {
    location: {
      type: String,
      default: 'top'
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String
    },
    openDelay: {
      type: Number,
      default: 500
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isDarkMode() {
      return this.$vuetify.theme.name === 'dark'
    }
  }
}
</script>

<style scoped></style>
